export default __webpack_public_path__ + "static/media/logo3.f03863be.png";